import React from "react";

interface SynkSwapProps {
  customUrl?: string;
  mode?: string;
  fromAmount?: string;
}

const SynkSwap: React.FC<SynkSwapProps> = ({ customUrl, mode, fromAmount }) => {
  // URL directe sans useState ni useEffect
  let url = "https://swap.synk.ws";

  if (customUrl) {
    url = customUrl;
  } else if (mode && fromAmount) {
    url = `https://swap.synk.ws/?mode=${mode}&fromAmount=${fromAmount}`;
  }

  // Logs de débogage si en mode dev
  if (process.env.REACT_APP_DEV_MODE === "true") {
    console.log("🔐 SynkSwap - Props reçues:");
    console.log("  - customUrl:", customUrl);
    console.log("  - mode:", mode);
    console.log("  - fromAmount:", fromAmount);
    console.log("  - URL finale:", url);
  }

  return (
    <div className="w-full h-full">
      <iframe
        src={url}
        title="Synk Swap"
        className="w-full h-full border-none"
        sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-clipboard-write"
        allow="camera; microphone; fullscreen; clipboard-write"
      />
    </div>
  );
};

export default SynkSwap;
